export const FlashcardsCommonTranslations = {
  COLLECTIONS: {
    es: 'Colecciones',
    en: 'Collections',
    cat: 'Col·leccions',
    eus: 'Kollekzioak',
    pt: 'Coleções'
  },
  GROUP_YOUR_FLASHCARDS: {
    es: 'Agrupa tus flashcards en colecciones',
    en: 'Group your flashcards into collections',
    cat: 'Agrupa les teves targetes de memòria en col·leccions',
    eus: 'Ikusi-gure flashkarta-kolekzioak',
    pt: 'Agrupar suas flashcards em coleções'
  },
  CREATE_COLLECTIONS: {
    es: 'Crea colecciones para estudiar de forma organizada y eficiente.',
    en: 'Create collections to study in an organized and efficient way.',
    cat: 'Crea col·leccions per estudiar de forma organitzada i eficient.',
    eus: 'Ezabatu kolekzioak ikusi-gure flashkarta-kolekzioak',
    pt: 'Criar coleções para estudar de forma organizada e eficiente.'
  },
  PRACTICE: {
    es: 'Practicar',
    en: 'Practice',
    cat: 'Practicar',
    eus: 'Jarraitu',
    pt: 'Practicar'
  },
  FLASHCARDS: {
    es: 'Flashcards',
    en: 'Flashcards',
    cat: 'Flashcards',
    eus: 'Flashcards',
    pt: 'Flashcards'
  },
  DELETE_COLLECTION_CONFIRMATION: {
    es: '¿Estás seguro de querer eliminar esta colección?',
    en: 'Are you sure you want to delete this collection?',
    cat: 'Estàs segur que vols eliminar aquesta col·lecció?',
    eus: 'Ziur al zaude hau kollekzioa ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja excluir esta coleção?'
  },
  EDIT_COLLECTION: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  DELETE_COLLECTION: {
    es: 'Eliminar',
    en: 'Delete',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Excluir'
  },
  FLASHCARD_CREATED_SUCCESSFULLY: {
    es: 'Flashcard creada correctamente',
    en: 'Flashcard created successfully',
    cat: 'Flashcard creada correctament',
    eus: 'Flashkarta-tarjeta ongi sortu',
    pt: 'Flashcard criada com sucesso'
  },
  FLASHCARD_UPDATED_SUCCESSFULLY: {
    es: 'Flashcard modificada correctamente',
    en: 'Flashcard updated successfully',
    cat: 'Flashcard actualitzada correctament',
    eus: 'Flashkarta-tarjeta editatu ongi',
    pt: 'Flashcard atualizada com sucesso'
  },
  FLASHCARD_REMOVED_SUCCESSFULLY: {
    es: 'Flashcard eliminada correctamente',
    en: 'Flashcard removed successfully',
    cat: 'Flashcard eliminada correctament',
    eus: 'Flashkarta-tarjeta ongi ezabatu',
    pt: 'Flashcard removida com sucesso'
  },
  FLASHCARD_MOVED_SUCCESSFULLY: {
    es: 'Se ha movido la flashcard correctamente',
    en: 'The flashcard has been moved correctly',
    cat: 'La targeta de memòria ha estat movida correctament',
    eus: 'Flashkarta-tarjeta ongi mugitu',
    pt: 'A flashcard foi movida com sucesso'
  },
  FLASHCARD_COLLECTION_CREATED_SUCCESSFULLY: {
    es: 'Colección de flashcards creada correctamente',
    en: 'Flashcard collection created successfully',
    cat: 'Col·lecció de targetes de memòria creada correctament',
    eus: 'Flashkarta-kolekzioa ongi sortu',
    pt: 'Coleção de flashcards criada com sucesso'
  },
  FLASHCARD_COLLECTION_UPDATED_SUCCESSFULLY: {
    es: 'Colección de flashcards actualizada correctamente',
    en: 'Flashcard collection updated successfully',
    cat: 'Col·lecció de targetes de memòria actualitzada correctament',
    eus: 'Flashkarta-kolekzioa ongi editatu',
    pt: 'Coleção de flashcards atualizada com sucesso'
  },
  FLASHCARD_COLLECTION_REMOVED_SUCCESSFULLY: {
    es: 'Colección eliminada correctamente',
    en: 'Flashcard collection removed successfully',
    cat: 'Col·lecció de targetes de memòria eliminada correctament',
    eus: 'Flashkarta-kolekzioa ongi ezabatu',
    pt: 'Coleção de flashcards removida com sucesso'
  },
  ERROR_GENERATING_FLASHCARD: {
    es: 'Error al generar las flashcards',
    en: 'Error generating flashcards',
    cat: 'Error al generar les targetes de memòria',
    eus: 'Flashkarta-kolekzioaren sortzearen errorea',
    pt: 'Erro ao gerar as flashcards'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Ikastarok',
    pt: 'Curso'
  },
  PRIVATE_COLLECTION: {
    es: 'Esta colección es privada',
    en: 'This collection is private',
    cat: 'Aquesta col·lecció és privada',
    eus: 'Hau kollekzioa pribatua da',
    pt: 'Esta coleção é privada'
  },
  EMPTY_FLASHCARDS: {
    es: 'Aún no hay flashcards',
    en: 'No flashcards yet',
    cat: 'Encara no hi ha targetes de memòria',
    eus: 'Ora ez dago flashkarta-tarjetaik',
    pt: 'Ainda não há flashcards'
  },
  CREATE_FIRST_FLASHCARD: {
    es: 'Crea la primera para empezar a memorizar el tema.',
    en: 'Create the first one to start memorizing the topic.',
    cat: 'Crea la primera per començar a memoritzar el tema.',
    eus: 'Sortu lehen bat memorizatzeko hasi.',
    pt: 'Crie o primeiro para começar a memorizar o tema.'
  },
  CREATE_FLASHCARD: {
    es: 'Crear flashcard',
    en: 'Create flashcard',
    cat: 'Crear flashcard',
    eus: 'Flashkarta-tarjeta sortu',
    pt: 'Criar flashcard'
  }
};
